import { axCoerceString } from '@awayfl/avm2';
export function fscommand(sec, command, args) {
    command = axCoerceString(command);
    args = axCoerceString(args);
    console.log('FSCommand: ' + command + '; ' + args);
    command = command.toLowerCase();
    if (command === 'debugger') {
        /* tslint:disable */
        debugger;
        /* tslint:enable */
        return;
    }
    sec.player.executeFSCommand(command, args);
}
